if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.activeTab = "sparpakete"; // Default to Sparpakete tab
      this.isTabSwitching = false;
      this.isUserClick = false;
      this.isInitialized = false;
      // this.initTabs();
    }

    get selectedOptionValues() {
      const options = this.querySelectorAll(
        ".m-product-option select, .m-product-option input"
      );
      const selectedValues = new Map();

      options.forEach((field) => {
        const fieldName = field.value || field.dataset.fieldName;
        if (field.tagName.toLowerCase() === "select") {
          const selectedOption = Array.from(field.options).find(
            (opt) => opt.selected && !opt.disabled
          );
          if (selectedOption) {
            selectedValues.set(fieldName, selectedOption.dataset.optionValueId);
          }
        } else if (
          field.tagName.toLowerCase() === "input" &&
          field.type === "radio"
        ) {
          const checkedInput = field.checked ? field : null;
          if (checkedInput) {
            selectedValues.set(fieldName, checkedInput.dataset.optionValueId);
          }
        }
      });

      const result = [];
      options.forEach((field) => {
        const fieldName = field.value || field.dataset.fieldName;
        if (selectedValues.has(fieldName)) {
          const optionValueId = selectedValues.get(fieldName);
          if (optionValueId && !result.includes(optionValueId)) {
            result.push(optionValueId);
          }
        }
      });
      return result;
    }

    connectedCallback() {
      this.addEventListener("change", (event) => {
        // Set flag to indicate this is a user-initiated change
        this.isUserClick = true;

        const target = this.getInputForEventTarget(event.target);
        MinimogEvents.emit(
          MinimogTheme.pubSubEvents.optionValueSelectionChange,
          {
            data: {
              selectedOptionValues: this.selectedOptionValues,
              event,
              target,
            },
          }
        );

        // Reset the flag after a longer delay to ensure product-info skips update
        // setTimeout(() => {
        //   this.isUserClick = false;
        // }, 600);
      });

      // Initialize tab functionality
      this.initTabs();
    }

    disconnectedCallback() {
      console.log(`disconnectedCallback called`);

      // Store the currently selected variant before component is destroyed
      const selectedInput = this.querySelector('input[type="radio"]:checked');
      if (selectedInput) {
        // Store in a global variable or data attribute that survives component destruction
        window.__lastSelectedVariantId = selectedInput.dataset.optionValueId;
        window.__lastSelectedVariantValue = selectedInput.value;
        window.__lastSelectedVariantTab =
          selectedInput.closest("[data-tab]")?.dataset.tab;
        console.log(
          `Storing selected variant: ID=${window.__lastSelectedVariantId}, Value=${window.__lastSelectedVariantValue}, Tab=${window.__lastSelectedVariantTab}`
        );
      }

      // Reset initialization flag when component is removed from DOM
      this.isInitialized = false;
    }

    initTabs() {
      console.log(`initTabs method is called`);

      // Prevent multiple initializations
      if (this.isInitialized) {
        console.log(`Already initialized, skipping initTabs`);
        return;
      }

      const tabs = this.querySelectorAll(".variant-tab");
      if (tabs.length === 0) return;

      tabs.forEach((tab) => {
        tab.addEventListener("click", (e) => {
          e.preventDefault();
          this.switchTab(tab.dataset.tab);
        });
      });

      // Set initial tab state and ensure proper variant visibility
      this.switchTab(this.activeTab);

      // Force initial state to ensure proper CSS application
      setTimeout(() => {
        this.forceInitialState();
      }, 100);

      // Mark as initialized
      this.isInitialized = true;
    }

    forceInitialState() {
      // Ensure Sparpakete variants are visible and Einzelleuchte are hidden
      const sparpaketeVariants = this.querySelectorAll(
        '.m-product-option--node[data-tab="sparpakete"]'
      );
      const einzelleuchteVariants = this.querySelectorAll(
        '.m-product-option--node[data-tab="einzelleuchte"]'
      );

      sparpaketeVariants.forEach((variant) => {
        variant.style.display = "block";
        variant.classList.remove("m:hidden");
        variant.style.opacity = "1";
        variant.style.transform = "scale(1)";
        variant.style.pointerEvents = "auto";
      });

      einzelleuchteVariants.forEach((variant) => {
        variant.style.display = "none";
        variant.classList.add("m:hidden");
        variant.style.opacity = "0";
        variant.style.transform = "scale(0.95)";
        variant.style.pointerEvents = "none";
      });
    }

    switchTab(tabName) {
      console.log(`swithTab method is called: `, tabName);
      console.log(`this.activeTab: `, this.activeTab);
      // Prevent recursive calls if already switching to the same tab
      if (this.activeTab === tabName && this.isTabSwitching) {
        return;
      }

      this.isTabSwitching = true;
      this.activeTab = tabName;

      // Update tab button states
      const tabs = this.querySelectorAll(".variant-tab");
      tabs.forEach((tab) => {
        const isActive = tab.dataset.tab === tabName;
        tab.dataset.active = isActive.toString();

        if (isActive) {
          tab.classList.remove("m:bg-white");
          tab.classList.add("m:bg-orange-100");
        } else {
          tab.classList.remove("m:bg-orange-100");
          tab.classList.add("m:bg-white");
        }
      });

      // Show/hide variant options based on tab
      const variantOptions = this.querySelectorAll(
        ".m-product-option--node[data-tab]"
      );
      variantOptions.forEach((option) => {
        const optionTab = option.dataset.tab;
        if (optionTab === tabName) {
          option.style.display = "block";
          option.classList.remove("m:hidden");
          option.style.opacity = "1";
          option.style.transform = "scale(1)";
          option.style.pointerEvents = "auto";
        } else {
          option.style.display = "none";
          option.classList.add("m:hidden");
          option.style.opacity = "0";
          option.style.transform = "scale(0.95)";
          option.style.pointerEvents = "none";
        }
      });

      // Handle variant selection when switching tabs (only for programmatic tab switches)
      if (!this.isUserClick) {
        // this.handleTabVariantSelection(tabName);
      }

      // Emit custom event for tab change
      this.dispatchEvent(
        new CustomEvent("tabChanged", {
          detail: { activeTab: tabName },
        })
      );

      // Reset the switching flag after a brief delay
      setTimeout(() => {
        this.isTabSwitching = false;
      }, 50);
    }

    handleTabVariantSelection(tabName) {
      // Don't auto-select variants during user interactions
      if (this.isUserClick) {
        console.log(`Skipping auto-selection due to user interaction`);
        return;
      }

      // Find the first available variant in the selected tab
      const visibleOptions = this.querySelectorAll(
        `.m-product-option--node[data-tab="${tabName}"]:not(.m-product-option--node__unavailable)`
      );

      // Check if any variant is already selected in this tab
      const checkedInput = this.querySelector(
        `.m-product-option--node[data-tab="${tabName}"] input[type="radio"]:checked`
      );

      // Check if we need to restore a previously selected variant
      if (window.__lastSelectedVariantId && !checkedInput) {
        console.log(
          `Attempting to restore variant: ID=${window.__lastSelectedVariantId}, Tab=${window.__lastSelectedVariantTab}`
        );

        // Try multiple ways to find the target input
        let targetInput = this.querySelector(
          `input[type="radio"][data-option-value-id="${window.__lastSelectedVariantId}"]`
        );

        if (!targetInput && window.__lastSelectedVariantValue) {
          targetInput = this.querySelector(
            `input[type="radio"][value="${window.__lastSelectedVariantValue}"]`
          );
        }

        if (!targetInput) {
          // Try finding by name pattern or other attributes
          const allInputs = this.querySelectorAll('input[type="radio"]');
          console.log(
            `Found ${allInputs.length} radio inputs, searching for match...`
          );
          allInputs.forEach((input) => {
            console.log(
              `Input: value=${input.value}, optionValueId=${input.dataset.optionValueId}`
            );
          });
        }

        if (targetInput) {
          console.log(
            `Successfully found and restoring variant: ${window.__lastSelectedVariantId}`
          );
          targetInput.checked = true;

          // Clear the stored selections
          delete window.__lastSelectedVariantId;
          delete window.__lastSelectedVariantValue;
          delete window.__lastSelectedVariantTab;
          return;
        } else {
          console.log(
            `Could not find target input for variant: ${window.__lastSelectedVariantId}`
          );
        }
      }

      // Only auto-select if no variant is currently selected in this tab
      if (visibleOptions.length > 0 && !checkedInput) {
        const firstOption = visibleOptions[0];
        const radioInput = firstOption.querySelector('input[type="radio"]');

        if (radioInput && !radioInput.checked) {
          console.log(`Auto-selecting first variant in tab: ${tabName}`);
          radioInput.checked = true;
          // Trigger change event to update product info
          radioInput.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
    }

    getInputForEventTarget(target) {
      return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
    }
  }
  customElements.define("variant-picker", VariantPicker);
}

